import * as type from "../types/calendar";

const initialCalendarState = {
  events: [],
  activeId: null,
  fetchFullCalendar: {
    error: null,
    loading: true,
  },
  addEvent: {
    status: null,
    loading: false,
    error: null,
  },
  deleteEvent: {
    status: null,
    loading: false,
    error: null,
  },
  updateEvent: {
    status: null,
    loading: false,
    error: null,
  },
  activeEvent: {
    key: null,
    title: null,
    startDate: null,
    endDate: null,
    startTime: null,
    endTime: null,
    description: null,
  },
  showModals: {
    addModal: false,
    editModal: false,
  },
};

export const calendar = (state = initialCalendarState, payload) => {
  switch (payload.type) {
    case type.REQUEST_CALENDAR_CONTENT:
      return {
        ...state,
        fetchFullCalendar: {
          ...state.fetchFullCalendar,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_CALENDAR_CONTENT:
      return {
        ...state,
        events: [],
        fetchFullCalendar: {
          ...state.fetchFullCalendar,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_CALENDAR_CONTENT:
      return {
        ...state,
        events: payload.events,
        fetchFullCalendar: {
          ...state.fetchFullCalendar,
          error: null,
          loading: false,
        },
      };
    case type.RESET_CALENDAR_CONTENT:
      return {
        ...state,
        events: [],
        fetchFullCalendar: {
          ...state.fetchFullCalendar,
          error: null,
          loading: false,
        },
      };
    case type.CHANGE_CALENDAR_MODALS:
      if (payload.modal.addModal === true || payload.modal.addModal === false) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addModal: payload.modal.addModal,
          },
        };
      } else if (
        payload.modal.editModal === true ||
        payload.modal.editModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editModal: payload.modal.editModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_ADD_CALENDAR_EVENT:
      return {
        ...state,
        addEvent: {
          ...state.addEvent,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_CALENDAR_EVENT:
      return {
        ...state,
        addEvent: {
          ...state.addEvent,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_CALENDAR_EVENT:
      return {
        ...state,
        addEvent: {
          ...state.addEvent,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.GRANT_ADD_CALENDAR_EVENT:
      return {
        ...state,
        addEvent: {
          ...state.addEvent,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.SET_ACTIVE_CALENDAR_DISPLAY:
      return {
        ...state,
        activeEvent: {
          ...state.activeEvent,
          title: payload.info.title,
          description: payload.info.description,
          startTime: payload.info.startTime,
          endTime: payload.info.endTime,
          endDate: payload.info.endDate,
          startDate: payload.info.startDate,
          key: payload.info.key,
        },
      };
    case type.RESET_ACTIVE_CALENDAR_DISPLAY:
      return {
        ...state,
        activeEvent: {
          ...state.activeEvent,
          title: null,
          description: null,
          startTime: null,
          endTime: null,
          endDate: null,
          startDate: null,
          key: null,
        },
      };
    case type.REQUEST_DELETE_CALENDAR_EVENT:
      return {
        ...state,
        deleteEvent: {
          ...state.deleteEvent,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_CALENDAR_EVENT:
      return {
        ...state,
        deleteEvent: {
          ...state.deleteEvent,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_DELETE_CALENDAR_EVENT:
      return {
        ...state,
        deleteEvent: {
          ...state.deleteEvent,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.GRANT_DELETE_CALENDAR_EVENT:
      return {
        ...state,
        deleteEvent: {
          ...state.deleteEvent,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_CALENDAR_EVENT:
      return {
        ...state,
        updateEvent: {
          ...state.updateEvent,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_CALENDAR_EVENT:
      return {
        ...state,
        updateEvent: {
          ...state.updateEvent,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_CALENDAR_EVENT:
      return {
        ...state,
        updateEvent: {
          ...state.updateEvent,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_CALENDAR_EVENT:
      return {
        ...state,
        updateEvent: {
          ...state.updateEvent,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
